import { getOrderPayableAmount } from './paymentStatusDisplay'

/** Order currently has an active verified SAP existing-balance payment. */
export function orderHasExistingBalanceApplied(order) {
  const detail = order?.payment_proof_detail
  const requests = Array.isArray(detail?.requests) ? detail.requests : []
  const proofs = Array.isArray(detail?.proofs) ? detail.proofs : []
  if (!requests.length || !proofs.length) return false
  const payablePaisa = Math.round(getOrderPayableAmount(order) * 100)
  for (const req of requests) {
    if (String(req?.status || '').toUpperCase() !== 'VERIFIED') continue
    const existingProofs = proofs.filter(
      (p) =>
        p.request_id === req.id &&
        String(p?.payment_method || '').toUpperCase() === 'EXISTING_BALANCE',
    )
    if (!existingProofs.length) continue
    const receivedPaisa = Math.round(
      Number(req.received_amount ?? req.requested_amount ?? 0) * 100,
    )
    if (payablePaisa <= 0 || receivedPaisa >= payablePaisa) return true
  }
  return false
}
